/*

https://github.com/angular/angular/issues/23141#issuecomment-379493753

you cannot directly bootstrap an Angular component that contains upgraded components before 
bootstrapping AngularJS. Instead, you can downgrade AppComponent and let it be bootstrapped
 as part of the AngularJS part of the app.

 It looks like if CurrentUser was an Angular service, this could work

*/
import { Inject, Injectable } from '@angular/core';
import { CurrentUserService } from './shared/services/current-user.service';
import { AssetSearchService } from './assets/data-access/assetSearch.service';


@Injectable()
export class AppInitService {

    constructor(
        private currentUser: CurrentUserService,
        private assetSearchService: AssetSearchService
    ) {//@Inject('CurrentUser') private currentUser:CurrentUser
    }

    Init() {
        this.assetSearchService.warmCountriesInBackground();
        //  return this.currentUser.get().toPromise();
    }
}


